import { configureStore } from '@reduxjs/toolkit'

import systemReducer from './system/systemSlice'
import userReducer from './user/userSlice'
import eventMembersReducer from './eventMembers/eventMembersSlice'
import eventsSlice from './events/eventsSlice'
import horseSlice from './horses/horseSlice'
import exhibitorSlice from './exhibitor/exhibitorSlice'
import filterSlice from './filters/filterSlice'
import ticketslice from './tickets/ticketslice'
import filesSlice from './files/filesSlice'
import billsSlice from './bills/billsSlice'
import paperworkSlice from './paperworks/paperworkSlice'
import followingSlice from './following/followingSlice'
import registrationSlice from './registration/registrationSlice'
import registerExhibitorSlice from './registerExhibitor/registerExhibitorSlice'
import organizerSlice from './organizer/organizerSlice'
import profilePageSlice from './profilePage/profilePageSlice'
import registerMobileMenuSlice from './mobileMenu/mobileMenuSlice'
import riderSlice from './rider/riderSlice'
import organizersSlice from './organizers/organizersSlice'
import riderProfileRegistrationSlice from './riderProfileRegistration/riderProfileRegistrationSlice'
import financesSlice from './finances/financesSlice'

const store = configureStore({
  reducer: {
    files: filesSlice,
    user: userReducer,
    bills: billsSlice,
    horses: horseSlice,
    events: eventsSlice,
    filters: filterSlice,
    tickets: ticketslice,
    eventMembers: eventMembersReducer,
    system: systemReducer,
    organizer: organizerSlice,
    organizers: organizersSlice,
    exhibitor: exhibitorSlice,
    following: followingSlice,
    rider: riderSlice,
    riderProfileRegistration: riderProfileRegistrationSlice,
    paperworks: paperworkSlice,
    registration: registrationSlice,
    registerExhibitors: registerExhibitorSlice,
    profilePage: profilePageSlice,
    mobileMenu: registerMobileMenuSlice,
    finances: financesSlice,
  },
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type IReduxStatus = 'idle' | 'loading' | 'fulfilled' | 'failed'

export default store
